import React, { useEffect } from 'react';

import { Button, Caption2, Caption3, H3 } from 'components/Common';
import Spacing from 'components/Common/Spacing';

import { Container, Modal } from '../page404/styles';

/**
 * @description
 * react-router 데이터 라우터의 errorElement.
 *
 * 기본 에러화면("Unexpected Application Error!")이 그대로 노출되던 것을 대체한다 —
 * 그 문구가 구글 검색에 페이지 제목으로 색인된 사례가 있음(/register, 2026-07).
 * 렌더 중에만 robots noindex 를 걸어 어떤 에러 화면도 검색에 색인되지 않게 하고,
 * 청크 로드 실패류는 새로고침으로 대부분 해결되므로 새로고침 버튼을 기본 동작으로 제공한다.
 * (Page404/Page500 과 동일한 디자인 시스템 사용)
 */
const RouterErrorFallback = () => {
  useEffect(() => {
    // 에러 화면 노출 동안만 noindex (react-helmet-async 는 React 18 동시성 레이스로
    // meta 유실 가능성이 있어 직접 DOM 갱신 — web repo NoIndexMeta 와 동일 원리)
    const el = document.createElement('meta');
    el.setAttribute('name', 'robots');
    el.setAttribute('content', 'noindex');
    document.head.appendChild(el);
    return () => {
      el.remove();
    };
  }, []);

  return (
    <Container>
      <Modal>
        <img src="/Logo.svg" alt="체크메이트코리아 로고" width={159} height={36} />
        <Spacing height={30} />
        <H3>일시적인 오류가 발생했습니다</H3>
        <Spacing height={10} />
        <Caption2 color="Gray40" style={{ textAlign: 'center' }}>
          페이지를 불러오지 못했습니다.
          <br />
          새로고침하면 대부분 해결됩니다.
        </Caption2>
        <Spacing height={45} />
        <Button background="Gray20" width="100%" height="45px" onClick={() => window.location.reload()}>
          <Caption3 color="Gray40">새로고침</Caption3>
        </Button>
      </Modal>
    </Container>
  );
};

export default RouterErrorFallback;
